import { useCallback, useEffect, useRef, useState } from 'react';

import { COMPANY_DETAIL_MENU } from '~constant/company';
import useIntersectionObservers from '~hooks/useIntersectionObservers';
import { ValueOf } from '~types/common';

const findMenuIndex = (id: ValueOf<typeof COMPANY_DETAIL_MENU>) => {
  const menuOrder = Object.values(COMPANY_DETAIL_MENU);

  return menuOrder.findIndex((element) => element === id);
};

const options = { rootMargin: '-110px', threshold: 0 };

type MenuObserve = { [key in ValueOf<typeof COMPANY_DETAIL_MENU>]: boolean };

function useCardObserver() {
  const refs = useRef<HTMLElement[]>([]);
  const [menu, setMenus] = useState<MenuObserve | {}>({});
  const [selectedMenu, setSelectedMenu] = useState<ValueOf<typeof COMPANY_DETAIL_MENU>>(
    COMPANY_DETAIL_MENU.COMPANY_SUMMARY,
  );

  const updateEntry = useCallback((entries: IntersectionObserverEntry[]): void => {
    entries.map((entry) => {
      setMenus((prev) => ({ ...prev, [entry.target.id]: entry.isIntersecting }));
    });
  }, []);
  const entries = useIntersectionObservers(refs, options, updateEntry);

  const registerRef = useCallback(
    (element: HTMLElement, id: ValueOf<typeof COMPANY_DETAIL_MENU>) => {
      const index = findMenuIndex(id);

      if (!refs.current[index]) {
        refs.current[index] = element;
      }
    },
    [],
  );

  const getSelectedMenu = (menus: MenuObserve): ValueOf<typeof COMPANY_DETAIL_MENU> | undefined => {
    const menuOrder = Object.values(COMPANY_DETAIL_MENU);

    const filtertedMenu = (Object.keys(menus) as ValueOf<typeof COMPANY_DETAIL_MENU>[])
      .map((key) => menus[key] && key)
      .filter((value) => value);

    if (filtertedMenu.length < 0) return COMPANY_DETAIL_MENU.COMPANY_SUMMARY;

    // @ts-ignore
    let index = findMenuIndex(filtertedMenu[0]);
    (filtertedMenu as ValueOf<typeof COMPANY_DETAIL_MENU>[]).map((key) => {
      if (findMenuIndex(key) <= index) {
        index = findMenuIndex(key);
      }
    });

    return menuOrder[index];
  };

  const resetRefs = () => {
    refs.current = [];
  };

  useEffect(() => {
    // @ts-ignore
    setSelectedMenu((prev) => getSelectedMenu(menu) || prev);
  }, [entries, menu]);

  return { entries, selectedMenu, registerRef, resetRefs };
}

export default useCardObserver;
